export default "__VITE_ASSET__CAntS$VG__"